import { ENDPOINTS } from '../constants/endpoints';
import { serviceAxiosInstance, serviceAxiosInstanceAct } from '../config/api.service.config';

export function getAccountInfo(teamworkBpi, cntrctrNb) {
  return serviceAxiosInstance.get(ENDPOINTS['GET_ACCOUNT_INFO'] + teamworkBpi + '/' + cntrctrNb);
}

export function getRepoCommonInfo(teamworkBpi, cntrctrNb) {
  return serviceAxiosInstance.get(ENDPOINTS['GET_REPOCOMMON_INFO'] + teamworkBpi + '/' + cntrctrNb);
}

export function getCntrctrInfoForComments(userId) {
  return serviceAxiosInstance.get(ENDPOINTS['GET_CONTRACTOR_INFO_FOR_COMMENT'] + userId);
}

export function createPinnacleContact(pinncalelogobj, userid, password) {
  return serviceAxiosInstanceAct.post(ENDPOINTS['POST_PINNCAL_LOG'], pinncalelogobj);
}
export function getActionList() {
  return serviceAxiosInstance.get(ENDPOINTS['GET_ACTION_LIST'] );
}
